// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__6mMyG","notes":"Notes_notes__1xybs"};